import Mixpanel from 'common/services/stats/-RFC.Mixpanel';
import Recaptcha from 'services/recaptcha';
import { Session, SessionKeys } from 'common/services/-RFC.session.js';
import { MeRepository } from 'common/repositories/index';
import Alert from 'directives/dashboard/ui-alert/-RFC.ui-alert-logic';

const _serviceDependencies = ['$rootScope', '$interval', '$scope', 'Auth', 'Util', 'Sso', '$window', 'MyAccountCountriesService', 'UserRestService', '$state'];
/**
 * @ngdoc service
 * @name controllers.Register
 *
 * @description
 * Register controller
 */
class Register {

    /**
     * @param  {any} $scope
     * @param  {any} Auth
     * @param  {any} Util
     * @param  {any} Sso
     * @param  {any} $window
     */
    constructor(
        $rootScope, $interval, $scope, Auth, Util, Sso,
        $window, MyAccountCountriesService, UserRestService, $state,
    ) {

        this.Auth = Auth;
        this.Sso = Sso;
        this.$window = $window;
        this.Util = Util;
        this.Recaptcha = Recaptcha;
        this.$rootScope = $rootScope;
        this.$interval = $interval;
        this.$scope = $scope;
        this.$scope.submitted = false;
        this.$scope.socialMediaSubmitted = false;
        this.$scope.firstStepSubmited = false;
        this.Auth.error = false;
        this.Auth.loading = false;
        this.$scope.emailRegExp = this.Util.getEmailValidationRegExp();
        this.$scope.firstNameRegExp = this.Util.getFullNameValidationRegExp();
        this.$scope.lastNameRegExp = this.Util.getFullNameValidationRegExp();
        this.$scope.passwordRegExp = this.Util.getPasswordValidationRegExp();
        this.$scope.showChangeLang = true;
        this.$scope.showSocialLogin = true;
        this.$scope.showEmbeddedSocialLogin = false;
        this.$scope.clientId = 'dashboard';
        this.$scope.brandName = CWCONFIG.partnerConfig.name;
        this.$scope.hrefEndUser = CWCONFIG.partnerConfig.translationsLinks.eula.endUserLicenseAgreement.replace('{language}', CWCONFIG.language);
        this.$scope.hrefLegalTerms = CWCONFIG.partnerConfig.translationsLinks.eula.legalTerms.replace('{language}', CWCONFIG.language);
        this.$scope.hrefGeneralPrivacy = CWCONFIG.partnerConfig.translationsLinks.generalPrivacy.replace('{language}', CWCONFIG.language);
        this.$scope.hrefGeneralImprint = CWCONFIG.partnerConfig.translationsLinks.generalImprint.replace('{language}', CWCONFIG.language);
        this.$scope.$parent.setCaptchaResponse = this.setCaptchaResponse.bind(this);
        this.MeRepository = MeRepository;
        this.UserRestService = UserRestService;
        this.$state = $state;

        const user = this.MeRepository.getMyUser();
        this.$scope.countries = MyAccountCountriesService.getCountries();
        this.$rootScope.registerActiveStep = '1';
        this.$scope.country = '';

        if (user) {

            this.$scope.firstName = Util.deepFind(user, 'attributes.first_name') || '';
            this.$scope.lastName = Util.deepFind(user, 'attributes.last_name') || '';
            const userCountry = Util.deepFind(user, 'attributes.country') || '';
            this.$scope.country = this.$scope.countries.find(value =>
                value.code === userCountry);

        }

        this.$scope.validateEmailError = true;

        $scope.validateConfirmEnail = () => {

            if (this.$scope.email === this.$scope.confirmEmail) {

                this.$scope.validateEmailError = false;

            } else {

                this.$scope.validateEmailError = true;

            }

        };

        $scope.validateCountry = (country) => {

            if (country) {

                this.$scope.country = country;
                this.$scope.countryError = false;

            }

        };

        const initialUrl = String(Session.getValue(SessionKeys.InitialUrl));

        this.$scope.showCustomAuth = false;

        this.socialLoginUrl = initialUrl;

        // SSO thirParty login
        if (this.Sso.isThirdPartyLogin) {

            // hide change language button if we receive change_lang=false param in the url
            this.$scope.showChangeLang = this.Sso.getChangeLang();

            // show the back button if we receive a skip_uri param in the url
            this.skip_uri = this.Sso.getSkipUri();
            this.$scope.showSkipButton = this.skip_uri;

            // show the close button if we receive a close_button=true param in the url
            this.$scope.showCloseButton = this.Sso.getCloseButton();

            // hide the social login button if we receive a social_login=false param in the url
            this.$scope.showSocialLogin = this.Sso.getSocialLogin();

            // show the embedded social login button if we receive a embedded_social=true param
            this.$scope.showEmbeddedSocialLogin = this.Sso.getEmbeddedSocialLogin();

            this.$scope.clientId = this.Sso.getClientId();

            if (initialUrl.indexOf('client_id=spotlight') > -1) {

                /**
                 * Set the URL for the social button that will redirect to the Sso page
                 * in the browser with other default values
                 */
                const token = Util.getToken();
                // close the embedded sso page if sso token is missing
                if (!token || token === 'undefined') {

                    if (window.external && ('CloseHtml' in window.external)) {

                        window.external.CloseHtml('social login redirect to dashboard');

                    }

                }
                this.socialLoginUrl = this.socialLoginUrl
                    .replace('embedded_social=true', 'embedded_social=false')
                    .replace('social_login=false', 'social_login=true')
                    .replace('change_lang=false', 'change_lang=true')
                    .replace('embedded=true', 'embedded=false')
                    .replace(Util.getParams(initialUrl).access_token, token);

                // this means user landed in login page and switched tabs to register
                // so our redirect must now be to register
                if (this.socialLoginUrl.indexOf('auth/login') > -1) {

                    this.socialLoginUrl = this.socialLoginUrl.replace('auth/login', 'auth/register');

                }

            }

        }

        Mixpanel.send('ConnectWeb Auth Register Open', {
            Source: 'Direct',
        });
        this.passwordScore = {};

        this.$scope.$on('$destroy', () => {

            if (this.$scope.showCustomAuth) {

                angular.element('.landing-page-auth').show();

            }

        });

    }

    register() {

        const oauthPayload = {
            grant_type: 'client_credentials',
        };

        const headers = {};

        const captchaRespose = this.Recaptcha.getCaptchaResponse();

        if (captchaRespose) {

            headers['X-Avira-Captcha-Token'] = captchaRespose;

        }

        // UTC timestamp ISO 8601
        const timestamp = moment().toISOString();

        // retrieve the x-a-* params and forward them to the backend
        const ssoParams = this.Sso.getParams();
        const metaParams = {};
        Object.keys(ssoParams).forEach((key) => {

            if (key.indexOf('x-a-') > -1) {

                metaParams[key] = ssoParams[key];

            }

        });

        const userPayload = {
            type: 'users',
            data: {
                attributes: {
                    first_name: this.$scope.firstName,
                    last_name: this.$scope.lastName,
                    email: this.$scope.email,
                    password: this.$scope.password,
                    language: CWCONFIG.language,
                    gdpr_consent: timestamp,
                    country: this.$scope.country.code,
                },
            },
            meta: {
                'x-params': metaParams,
                check_ustc: true,
                check_ustc_synchronous: true,
            },
        };

        this.getPasswordScore(this.$scope.password);

        // Check if the username, email and password are valid
        const formIsValid = this.$scope.registerForm.$valid &&
                            this.passwordScore.valid &&
                            this.$scope.country.code;

        Mixpanel.send('ConnectWeb Register Click', {
            Page: 'Auth Register',
        });

        if (!this.$scope.country.name) {

            this.$scope.countryError = true;

        }

        this.$scope.submitted = true;

        let mixpanelError = '';

        if (formIsValid) {

            this.Auth.loading = true;

            // if the user is anonymous
            if (this.Util.isAnonymous()) {

                this.Auth.loginType = 'Register Anon'; // Login type for mixpanel event
                this.Auth.registerAnon(userPayload);

            } else {

                this.Auth.loginType = 'Register'; // Login type for mixpanel event
                this.Auth.register(oauthPayload, headers, userPayload);

            }

        } else {

            this.Util.triggerAnimation('.error', 'animated shake');

            if (this.$scope.registerForm.firstName.$invalid) {

                mixpanelError += 'name is empty, ';

            }

            if (this.$scope.registerForm.email.$invalid) {

                if (typeof this.$scope.registerForm.email.$viewValue === 'undefined' ||
                    this.$scope.registerForm.email.$viewValue === '') {

                    mixpanelError += 'email is empty, ';

                } else {

                    mixpanelError += 'email format not correct, ';

                }

            }

            if (this.$scope.registerForm.password.$invalid) {

                if (typeof this.$scope.registerForm.password.$viewValue === 'undefined' ||
                    this.$scope.registerForm.password.$viewValue === '') {

                    mixpanelError += 'password is empty, ';

                } else {

                    mixpanelError += 'password format not correct, ';

                }

            }

            Mixpanel.send('ConnectWeb Register Error', {
                'Error Name': mixpanelError.replace(/,\s*$/, ''), // remove last ',' and ' '
            });

        }

    }

    onSubmit() {

        if (this.Recaptcha.captchaRetries <= this.Auth.failedLogins) {

            this.Recaptcha.enableCaptcha();

        }

        if (this.Recaptcha.isCaptchaRequired()) {

            this.Recaptcha.execute();

        } else {

            this.register();

        }

    }

    onSubmitSocialMedia() {

        const ssoParams = JSON.parse(sessionStorage.getItem('SsoExtraUrlParams'));

        const formIsValid = this.$scope.registerFormSocialMedia.$valid;
        const user = this.MeRepository.getMyUser();
        this.$scope.socialMediaSubmitted = true;
        const initialUrl = String(Session.getValue(SessionKeys.InitialUrl));

        if (!this.$scope.country.name) {

            this.$scope.countryError = true;

        }

        if (formIsValid) {

            this.$scope.submitSocialMediaLoading = true;
            const userPayload = {
                type: user.type,
                id: user.id,
                data: {
                    attributes: {
                        first_name: this.$scope.firstName,
                        last_name: this.$scope.lastName,
                        country: this.$scope.country.code,
                    },
                },
                meta: {
                    check_ustc: true,
                },
                relationships: {
                    provider: {
                        data: {
                            type: user.relationships.partner.data.type,
                            id: user.relationships.partner.data.id,
                        },
                    },
                },
            };

            if (this.$rootScope.userCheckSync) {

                userPayload.meta.check_ustc_synchronous = true;

            }

            this.UserRestService.update(user.id, userPayload).then((response) => {

                this.MeRepository.update(response.data.data);
                this.$scope.submitSocialMediaLoading = false;

                if (ssoParams) {

                    if (ssoParams.client_id === 'unicorn' && ssoParams.redirect_uri === 'avira-security://embargo') {

                        Alert.success('Submitted true');
                        this.$window.location.href = ssoParams.redirect_uri;

                    }

                }

                if (initialUrl.indexOf('client_id=spotlight') > -1) {

                    if (window.external && ('CloseHtml' in window.external)) {

                        window.external.CloseHtml('confirmed');

                    }

                }

            }).then(null, (error) => {

                this.$scope.submitSocialMediaLoading = false;
                const errorObj = this.Util.deepFind(error, 'data.errors')[0];
                const errorCode = this.Util.deepFind(errorObj, 'code');

                if (errorCode === '22906') {

                    this.$rootScope.isComingFromEmbargoedCountry = true;

                    if (initialUrl.indexOf('client_id=spotlight') > -1 &&
                        initialUrl.indexOf('action=user_check_sync') > -1) {

                        this.$rootScope.showLoginTitle = true;

                    }

                    this.UserRestService.getMeAsync().then((response) => {

                        this.MeRepository.update(response.data.data);

                    });

                }

            });

        } else {

            this.$scope.socialMediaSubmitted = true;
            this.Util.triggerAnimation('.error', 'animated shake');

        }

    }

    setCaptchaResponse(response) {

        this.Recaptcha.setCaptchaResponse(response);
        this.register();

    }

    // SSO skip the login and redirect to skip_uri received in params
    skip() {

        Mixpanel.send('ConnectWeb Skip Click', {
            Page: 'Auth Login',
        });

        this.$window.location = this.$scope.skipUri;

    }

    showPassword() {

        const inputType = angular.element('#password')[0];

        if (inputType.type === 'text') {

            inputType.type = 'password';

        } else {

            inputType.type = 'text';

        }

        this.$scope.inputType = inputType.type;

    }

    getPasswordScore(password) {

        this.passwordScore = this.Util.getPasswordScore(password);

    }

    // redirect from Spotlight to dashboard Sso in the default browser of the user
    socialLoginRedirect() {

        if (window.external && ('OpenUrl' in window.external)) {

            window.external.OpenUrl(this.socialLoginUrl);

        } else {

            window.open(this.socialLoginUrl, '_blank');

        }

        if (window.external && ('CloseHtml' in window.external)) {

            window.external.CloseHtml('social login redirect to dashboard');

        }

    }

    proceedToNextStep() {

        this.$scope.firstStepSubmited = true;
        this.$scope.submitted = false;

        if (this.$scope.registerForm.email.$valid &&
            !this.$scope.validateEmailError &&
            this.$scope.registerForm.password.$valid &&
            this.passwordScore.valid) {

            this.$rootScope.registerActiveStep = '2';

            if (this.$rootScope.requestCountry) {

                this.$scope.country = this.$scope.countries.find(value =>
                    value.code === this.$rootScope.requestCountry);

            }

        } else {

            this.Util.triggerAnimation('.error', 'animated shake');

        }

    }

}
_serviceDependencies.push(Register);

angular.module('controllers')
    .controller('Register', _serviceDependencies);



// WEBPACK FOOTER //
// ./scripts/controllers/auth/register/register.js